enum Menu {
    LIST = 'list',
    MAP = 'map',
}; // eslint-disable-line

export default Menu;
